<template>
  <div id="document-svg-icon" class="flex items-center">
    <div ref="DocumentSvgIcon" :class="svgClasses"></div>
  </div>
</template>

<script>
export default {
  name: "M.DocumentIcon",
  props: {
    type: {
      type: String,
      required: true
    },
    svgClasses: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      iconSrc: null,
    }
  },
  watch: {
    async type() {
      await this.setIcon();
    }
  },
  computed: {
  },
  methods: {
    getSrc(val) {
      return require(`@/assets/images/icons/document-manager/${ val }.svg`);
    },
    async setIcon() {
      this.iconSrc = this.getSrc(this.type);
      const svgText = await fetch(this.iconSrc).then(response => {
        return response.text();
      });

      if (this.$refs.DocumentSvgIcon) {
        this.$refs.DocumentSvgIcon.innerHTML = "";
      }

      const svgEl = document.createElement('span');
      svgEl.innerHTML = svgText;
      svgEl.id = "icon-svg";
      if (!this.$refs.DocumentSvgIcon) return;
      this.$refs.DocumentSvgIcon.append(svgEl);
    },
  },
  mounted() {
    this.setIcon();
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#document-svg-icon {
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>